<template>
  <div class="ts-app-shell_fh">
  <RegistrationQuestionnaire :currentPage="currentPageStep">
    <div class="check-list-form">
      <div class="content-type">
        <span>Intake Information</span>
      </div>
      <el-form
        :model="registrationAnswer"
        @submit.native.prevent="updateRegistrationAnswers"
      >
        <div v-if="activeMemberOfTheMilitary">
          <p class="heavy-text">Military Service</p>
          <!-- <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you currently in the US Military or a Veteran?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'MilitaryService.CurrentlyInTheMilitary'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.militaryService.currentlyInTheMilitary"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div> -->
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a member of the armed forces who is wounded, ill or injured and receiving treatment in a military facility or warrior transition unit?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'MilitaryService.WoundedIllOrInjured'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.militaryService.woundedIllOrInjured"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Have you attended a Transition Assistance Program (TAP) Workshop within the last three years?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'MilitaryService.AttendedTAP'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.militaryService.attendedTAP"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you within 24 months of retirement or 12 months of discharge from the military (Transitioning Service Member)?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'MilitaryService.TransitioningServiceMember'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.militaryService.transitioningServiceMember"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <p class="heavy-text">Veteran Information</p>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Have you served and were discharged from active duty as a member of National Guard or Reserve unit during an armed
                  conflict and or crisis involving national security (Title 10 Activation) for which a campaign badge is authorized?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.ServedAndDischarged'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.veteranInfo.servedAndDischarged"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Most recent Active Duty Begin Date:</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.ActiveDutyBeginDate'
                    )
                  "
                >
                  <el-date-picker
                    v-model="registrationAnswer.veteranInfo.activeDutyBeginDate"
                    type="date"
                    placeholder="MM/DD/YYY"
                    value-format="MM/dd/yyyy"
                    format="MM/dd/yyyy"
                    size="small"
                    :picker-options="{disabledDate: disableTodayFutureDate}"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Most recent Active Duty End Date:</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.ActiveDutyEndDate'
                    )
                  "
                >
                  <el-date-picker
                    v-model="registrationAnswer.veteranInfo.activeDutyEndDate"
                    type="date"
                    placeholder="MM/DD/YYY"
                    value-format="MM/dd/yyyy"
                    format="MM/dd/yyyy"
                    size="small"
                    :picker-options="{disabledDate: disableTodayFutureDate}"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Branch of Service</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.BranchOfService'
                    )
                  "
                >
                  <el-select v-model="registrationAnswer.veteranInfo.branchOfService" placeholder="Select">
                    <el-option
                      v-for="item in branchOfServiceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Most Recent Character of Service Received</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.CharacterOfServiceReceived'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.veteranInfo.characterOfServiceReceived"
                    class="ml-4"
                  >
                    <el-row>
                      <el-radio label="Bad Conduct Discharge (BCD)" size="large">Bad Conduct Discharge (BCD)</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Dishonorable Discharge" size="large">Dishonorable Discharge</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="General" size="large">General</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Honorable" size="large">Honorable</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Other" size="large">Other</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Other Than Honorable (OTH)" size="large">Other Than Honorable (OTH)</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Uncharacterized" size="large">Uncharacterized</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Under Other Than Honorable Conditions" size="large">Under Other Than Honorable Conditions</el-radio>
                    </el-row>                  
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Do you have prior service dates?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.PriorServiceDate'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.veteranInfo.priorServiceDate"
                    class="ml-4"
                    @change="handlePriorServiceChange"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item"
            v-if="registrationAnswer.veteranInfo.priorServiceDate == 0">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Previous Active Duty Begin Date:</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.PreviousActiveDutyBeginDate'
                    )
                  "
                >
                  <el-date-picker
                    v-model="registrationAnswer.veteranInfo.previousActiveDutyBeginDate"
                    type="date"
                    placeholder="MM/DD/YYY"
                    value-format="MM/dd/yyyy"
                    format="MM/dd/yyyy"
                    size="small"
                    :picker-options="{disabledDate: disableTodayFutureDate}"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item"
            v-if="registrationAnswer.veteranInfo.priorServiceDate == 0">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Previous Active Duty End Date:</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.PreviousActiveDutyEndDate'
                    )
                  "
                >
                  <el-date-picker
                    v-model="registrationAnswer.veteranInfo.previousActiveDutyEndDate"
                    type="date"
                    placeholder="MM/DD/YYY"
                    value-format="MM/dd/yyyy"
                    format="MM/dd/yyyy"
                    size="small"
                    :picker-options="{disabledDate: disableTodayFutureDate}"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Received a Military Campaign Badge?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.MilitaryCampaignBadge'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.veteranInfo.militaryCampaignBadge"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item"
            v-if="registrationAnswer.priorityOfService.discloseDisability == 0">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Disabled Veteran</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.DisabledVeteran'
                    )
                  "
                >
                  <el-select v-model="registrationAnswer.veteranInfo.disabledVeteran" placeholder="Select">
                    <el-option
                      v-for="item in disabledVeteranOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item"
            v-if="registrationAnswer.priorityOfService.discloseDisability == 0">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Received Services from Veteran's VOC Rehab (Chapter 31):
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.VOCRehab'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.veteranInfo.vocRehab"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you currently incarcerated or have you been released from incarceration?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.Incarcerated'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.veteranInfo.incarcerated"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                    <el-radio :label="2" size="large">I do not wish to answer</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Within the last 12 months, have you been unemployed for 27 or more weeks?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.Unemployed'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.veteranInfo.unemployed"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                    <el-radio :label="2" size="large">Not sure</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Homeless Veteran:
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'VeteranInfo.Homeless'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.veteranInfo.homeless"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <p class="heavy-text">Transitioning Service Members</p>
          <p>Please indicate your transitioning type and transitioning service member discharge date.</p>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Transitioning Service Member Type:
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'TransitioningServiceMembers.MemberType'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.transitioningServiceMembers.memberType"
                    class="ml-4"
                  >
                    <el-row>
                      <el-radio label="Active Duty Transitioning" size="large">Active Duty Transitioning</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Reserve or National Guard Transitioning" size="large">Reserve or National Guard Transitioning</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Retiring Service Members" size="large">Retiring Service Members</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Veterans" size="large">Veterans</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Wounded, Ill, or Injured Service Members" size="large">Wounded, Ill, or Injured Service Members</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio label="Not applicable" size="large">Not applicable</el-radio>
                    </el-row>               
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Projected Discharge Date:</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'TransitioningServiceMembers.ProjectedDischargeDate'
                    )
                  "
                >
                  <el-date-picker
                    v-model="registrationAnswer.transitioningServiceMembers.projectedDischargeDate"
                    type="date"
                    placeholder="MM/DD/YYY"
                    value-format="MM/dd/yyyy"
                    format="MM/dd/yyyy"
                    size="small"
                    :picker-options="{disabledDate: disableTodayFutureDate}"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Have you received a signed DD-2648 (Service Member Pre-Separation / Transition Counseling  and Career Readiness
                  Standards eForm) indicating you do not meet career readiness standards?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'TransitioningServiceMembers.ReceivedASignedDD2648'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.transitioningServiceMembers.receivedASignedDD2648"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you being involuntarily separated from active duty due to a reduction in-force?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'TransitioningServiceMembers.InvoluntarySeparated'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.transitioningServiceMembers.involuntarySeparated"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
        </div>  
        <div v-if="spouseOfActiveMemberOfTheMilitary">
          <p class="heavy-text">Spouse or Caregiver of a Military Member</p>
          <p>Spouse or family caregiver of a Military member or Veteran may be entitled to State and Federal benefits. Please answer
            the following questions.
          </p>
          <!-- <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you the spouse of a member of the armed forces who is on active duty?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'MilitaryMemberSpouse.SpouseOfAMemberOfTheArmedForces'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.militaryMemberSpouse.spouseOfAMemberOfTheArmedForces"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div> -->
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a spouse or family caregiver to a member of the armed forces who is wounded, ill or injured and receiving
                  treatment in a military or warrior transition unit?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'MilitaryMemberSpouse.SpouseOfAWoundedMilitaryMember'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.militaryMemberSpouse.spouseOfAWoundedMilitaryMember"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you the spouse of someone in active-duty military service, National Guard or Reserves who is currently
                  activated?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'MilitaryMemberSpouse.SpouseOfActiveDutyMilitaryService'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.militaryMemberSpouse.spouseOfActiveDutyMilitaryService"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you the spouse of a veteran who has a permanent, total service connected disability or had the disability at the time
                  of death, or died while the disability was in existence?
                  Or
                  A spouse of a service member on active duty who died or has been Missing In Action (MIA), captured in the line of duty
                  or forcibly detained for a total of more than 90 days?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'MilitaryMemberSpouse.SpouseOfActiveDutyMilitaryService'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.militaryMemberSpouse.spouseOfAVeteran"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
        </div>
        <div v-if="withDisability">
          <p class="heavy-text">Disability</p>
          <div class="form-note-section">
            <div class="icon-box"><i class="fas fa-exclamation fa-4x"></i></div>
            <div class="note-text-small">
              Providing this information is optional and refusal to provide disability information will not
              subject you to any adverse treatment. Information regarding your disability status will be
              kept confidential as provided by law and will be used in accordance with the law. Please
              note that for some programs, the information is needed to determine eligibility. Note too
              that you may be eligible for additional supports services and programs if you have a 
              disability.
            </div>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you receiving Supplemental Security Income (SSI)?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Disability.ReceivingSSI'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.disability.receivingSSI"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you receiving Social Security Disability Insurance (SSDI)?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Disability.ReceivingSSDI'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.disability.receivingSSDI"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a Ticketholder in the Social Security Administration's Ticket-to-Work Program?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Disability.TicketToWorkProgram'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.disability.ticketToWorkProgram"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you currently OR have you ever received Vocational Rehabilitation Services from a state-supported rehabilitation
                  agency or some other rehabilitation agency?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Disability.ReceivingVocationalRehabilitationalServices'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.disability.receivingVocationalRehabilitationalServices"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you deaf or do you have serious difficulty hearing?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Disability.DifficultyHearing'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.disability.difficultyHearing"
                    class="ml-4"
                  >     
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                    <el-radio :label="2" size="large">Not Specified</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
        </div>
        <div class="content-item action-section">
          <el-row>
            <el-col :span="8">
              <el-button
                class="ts-btn ts-btn-outline wioa-btn-outline"
                @click="backToDashboard"
              >
                Previous
              </el-button>
            </el-col>
            <el-col  :span="8">
              <el-button
                class="ts-btn ts-btn-secondary"
                @click="updateRegistrationAnswers"
              >
                Next
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </RegistrationQuestionnaire>
  <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import RegistrationQuestionnaire from "../../component/RegistrationQuestionnaire.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import dateUtils from "@/utils/date.utils";

export default {
  components: { 
    RegistrationQuestionnaire, 
    TSLoading,
  },
  data(){
    return{
      modelState: {},
      isLoading: false,
      registrationAnswer: {
        priorityOfService: {},
        militaryService: {},
        veteranInfo: {},
        transitioningServiceMembers: {},
        militaryMemberSpouse: {},
        disability: {},
      },
      militaryServiceEmpty: {
        currentlyInTheMilitary: null,
        woundedIllOrInjured: null,
        attendedTAP: null,
        transitioningServiceMember: null,
      },
      veteranInfoEmpty: {
        servedAndDischarged: null,
        activeDutyBeginDate: null,
        activeDutyEndDate: null,
        branchOfService: null,
        characterOfServiceReceived: null,
        priorServiceDate: null,
        previousActiveDutyBeginDate: null,
        previousActiveDutyEndDate: null,
        militaryCampaignBadge: null,
        disabledVeteran: null,
        vocRehab: null,
        incarcerated: null,
        unemployed: null,
        homeless: null,
      },
      transitioningServiceMembersEmpty: {
        memberType: null,
        projectedDischargeDate: null,
        receivedASignedDD2648: null,
        involuntarySeparated: null,
      },
      militaryMemberSpouseEmpty: {
        spouseOfAMemberOfTheArmedForces: null,
        spouseOfAWoundedMilitaryMember: null,
        spouseOfActiveDutyMilitaryService: null,
        spouseOfAVeteran: null,
      },
      disabilityEmpty: {
        receivingSSI: null,
        receivingSSDI: null,
        ticketToWorkProgram: null,
        receivingVocationalRehabilitationalServices: null,
        difficultyHearing: null,
      },
      jobSeekerId: null,
      branchOfServiceOptions: [{
          value: 'Army',
          label: 'Army'
        }, {
          value: 'Navy',
          label: 'Navy'
        }, {
          value: 'Air Force',
          label: 'Air Force'
        }, {
          value: 'Coastguard',
          label: 'Coastguard'
        }],
      disabledVeteranOptions: [{
        value: 'Yes',
        label: 'Yes'
      }, {
        value: 'No',
        label: 'No'
      }],
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    activeMemberOfTheMilitary() {
      if (this.registrationAnswer.priorityOfService.activeMemberOfTheMilitary === 0)
        return true;
      else 
        return false;
    },
    spouseOfActiveMemberOfTheMilitary() {
      if (this.registrationAnswer.priorityOfService.spouseOfAnActiveMemberOfTheMilitary === 0)
        return true;
      else 
        return false;
    },
    withDisability() {
      if (this.registrationAnswer.priorityOfService.discloseDisability === 0)
        return true;
      else 
        return false;
    },
    skipStepTwo() {
      return this.registrationAnswer.priorityOfService.activeMemberOfTheMilitary === 1 &&
        this.registrationAnswer.priorityOfService.spouseOfAnActiveMemberOfTheMilitary === 1 &&
        this.registrationAnswer.priorityOfService.discloseDisability === 1;
    },
  },
  created() {
    window.scrollTo(0,0);
    this.isLoading = true;
    this.jobSeekerId = this.$store.state.account.applicant_user_info.jobSeekerId;
    this.$store
      .dispatch("jobseeker/getRegistrationAnswerByJobSeekerId", this.jobSeekerId)
      .then((res) => {
        if (res === null || res === undefined || res.priorityOfService === null) {
          this.$router.push({ name: "RegistrationQuestionnaireOne" });
        } else {
          this.registrationAnswer = res;
          
          if (this.skipStepTwo) {
            this.$router.push({ name: "RegistrationQuestionnaireOne" });
          } else {
            this.registrationAnswer.militaryService = this.registrationAnswer.militaryService === null 
              ? this.militaryServiceEmpty 
              : this.registrationAnswer.militaryService;
            this.registrationAnswer.veteranInfo = this.registrationAnswer.veteranInfo === null 
              ? this.veteranInfoEmpty 
              : this.registrationAnswer.veteranInfo;
            this.registrationAnswer.transitioningServiceMembers = this.registrationAnswer.transitioningServiceMembers === null 
              ? this.transitioningServiceMembersEmpty 
              : this.registrationAnswer.transitioningServiceMembers;
            this.registrationAnswer.militaryMemberSpouse = this.registrationAnswer.militaryMemberSpouse === null 
              ? this.militaryMemberSpouseEmpty 
              : this.registrationAnswer.militaryMemberSpouse;
            this.registrationAnswer.disability = this.registrationAnswer.disability === null 
              ? this.disabilityEmpty 
              : this.registrationAnswer.disability;
          }
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    backToDashboard() {
      this.$router.push({ name: "RegistrationQuestionnaireOne" });
    },
    updateRegistrationAnswers() {
      this.isLoading = true;
      this.registrationAnswer.validatePageType = 2;

      if (!this.activeMemberOfTheMilitary) {
        this.registrationAnswer.militaryService = null;
        this.registrationAnswer.veteranInfo = null;
        this.registrationAnswer.transitioningServiceMembers = null;
      }
      if (!this.spouseOfActiveMemberOfTheMilitary) {
        this.registrationAnswer.militaryMemberSpouse = null;
      }
      if (!this.withDisability) {
        this.registrationAnswer.disability = null;
      }

      //EVA
      if(this.registrationAnswer.transitioningServiceMembers != null && this.registrationAnswer.transitioningServiceMembers.projectedDischargeDate != null)
        this.registrationAnswer.transitioningServiceMembers.projectedDischargeDate = dateUtils.formatDateToISOString(this.registrationAnswer.transitioningServiceMembers.projectedDischargeDate);

      if(this.registrationAnswer.veteranInfo != null && this.registrationAnswer.veteranInfo.activeDutyBeginDate != null)
        this.registrationAnswer.veteranInfo.activeDutyBeginDate = dateUtils.formatDateToISOString(this.registrationAnswer.veteranInfo.activeDutyBeginDate);

      if(this.registrationAnswer.veteranInfo != null && this.registrationAnswer.veteranInfo.activeDutyEndDate != null)
        this.registrationAnswer.veteranInfo.activeDutyEndDate = dateUtils.formatDateToISOString(this.registrationAnswer.veteranInfo.activeDutyEndDate);

      if(this.registrationAnswer.veteranInfo != null && this.registrationAnswer.veteranInfo.previousActiveDutyBeginDate != null)
        this.registrationAnswer.veteranInfo.previousActiveDutyBeginDate = dateUtils.formatDateToISOString(this.registrationAnswer.veteranInfo.previousActiveDutyBeginDate);

      if(this.registrationAnswer.veteranInfo != null && this.registrationAnswer.veteranInfo.previousActiveDutyEndDate != null)
        this.registrationAnswer.veteranInfo.previousActiveDutyEndDate = dateUtils.formatDateToISOString(this.registrationAnswer.veteranInfo.previousActiveDutyEndDate);

      this.$store
        .dispatch("jobseeker/updateRegistrationAnswer", this.registrationAnswer)
        .then(res => {
          if (res) {
            this.$router.push({ name: "RegistrationQuestionnaireThree" });
          }
        })
        .catch((resx) => {
          this.modelState = resx;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    disableTodayFutureDate(date) {
      return date.getTime() > Date.now();
    },
    handlePriorServiceChange() {
      this.registrationAnswer.veteranInfo.previousActiveDutyBeginDate = null;
      this.registrationAnswer.veteranInfo.previousActiveDutyEndDate = null;
    }
  },
};
</script>
<style scoped>

.fa-4x{
  color: #004085;
}

</style>